import { Button, Typography } from '@material-ui/core';
import { Backdrop } from '@room-match/shared-ui-components';
import { FrontLayout } from 'components';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { checkInService } from 'shared/services/checkInService';
import { projectService } from 'shared/services/projectService';
import { ls } from 'shared/utils/ls';
import { useStyles } from './CompleteCheckin.styles';

const { getSingleProject } = projectService();
const { getCheckInDetails } = checkInService();
const CompleteCheckin = () => {
  const { setLS, getLS } = ls();
  const classes = useStyles();
  const { projectId: projId, sessionId: sessId } = useParams() as { sessionId: string; projectId: string };
  const { data: checkinData, isLoading: checkinLoading } = getCheckInDetails(sessId);
  const { data, isLoading } = getSingleProject(projId);
  const authToken = getLS('auth_token');
  const getCompanyDetails = useMemo(() => {
    return data ? data.data.attributes : undefined;
  }, [data]);

  const handleClick = () => {
    window.location.href = `${ROUTES.TALENT.CHECKIN}/${projId}/${sessId}`;
  };

  const user = JSON.parse(getLS('user') || '{}');

  const talentName = `${user?.attributes?.stage_name || user?.attributes?.first_name}`;

  useEffect(() => {
    if (checkinLoading || isLoading) return;

    if (!authToken && projId && sessId) {
      setLS('complete_checkin', JSON.stringify({ projectId: projId, sessionId: sessId }));
      window.location.href = ROUTES.LOGIN;
    }
  }, [projId, sessId, isLoading, authToken]);

  if (isLoading || checkinLoading || !checkinData) return <Backdrop isLoading={true} />;
  if (!data)
    return (
      <FrontLayout containerWidth={1000}>
        <div className={classes.mainCont}>
          <Typography style={{ fontWeight: 600, fontSize: 18 }}>Invalid Project ID</Typography>
        </div>
      </FrontLayout>
    );

  if (checkinData?.data === null)
    return (
      <FrontLayout containerWidth={1000}>
        <div className={classes.mainCont}>
          <Typography style={{ fontWeight: 600, fontSize: 18 }}>Session Not Found</Typography>
        </div>
      </FrontLayout>
    );

  return (
    <FrontLayout containerWidth={1000}>
      <div className={classes.mainCont}>
        {getCompanyDetails?.logo ? (
          <img src={`${getCompanyDetails?.logo}`} className={classes.agencyLogo} />
        ) : (
          <div className={classes.logoPlaceholder}>{getCompanyDetails?.name}</div>
        )}
        <Typography style={{ fontSize: 24, margin: 20, fontWeight: 600 }}>Hello, {talentName}</Typography>
        <Typography style={{ fontSize: 24, margin: 20, textAlign: 'center' }}>
          We missed checking you in for your recent <span style={{ fontWeight: 600 }}>Audition</span> for the{' '}
          <span style={{ fontWeight: 600 }}>{data?.data.attributes.name} </span> project, with{' '}
          <span style={{ fontWeight: 600 }}>{data?.data.attributes.company_name}</span> auditioning for the role of{' '}
          <span style={{ fontWeight: 600 }}>
            {checkinData?.data.attributes.audition.data.attributes.casting_role.data.attributes.name}
          </span>{' '}
          under your{' '}
          <span style={{ fontWeight: 600 }}>
            {checkinData.data.attributes.audition.data.attributes.profile.data.attributes.agency_name ||
              checkinData.data.attributes.audition.data.attributes.profile.data.attributes.agency_full_name}
          </span>{' '}
          Profile.
        </Typography>

        {/* <Typography className={classes.welcomeMessage}>{getCompanyDetails?.welcome_message}</Typography> */}
        <Button
          color="primary"
          variant="contained"
          disableElevation
          className={`${classes.registerBtn} ${classes.buttonCls}`}
          onClick={handleClick}
        >
          Proceed with Check-in
        </Button>
      </div>
    </FrontLayout>
  );
};

export default CompleteCheckin;
